import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=342e112d"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"
import style0 from "./stock.vue?vue&type=style&index=0&id=342e112d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports